import {
  Flex,
  Text,
  Button,
  HStack,
  VStack,
  // TODO:  added to move to next line and remove eslint error
} from "native-base";
import colors from "theme/colors";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IN_STATUS_CHECK } from "global/paths";

const CheckStatusBox = () => {
  const { t } = useTranslation("common");
  return (
    <Flex
      bg={colors.neutral.cotton}
      mb="20px"
      statusCheckBox
      p="15px"
      py="10px"
      flex={1}
      borderRadius={12}
      maxWidth="1600px"
    >
      <HStack alignItems="center" space={3} style={{ flexWrap: "wrap" }}>
        <VStack style={{ flexWrap: "wrap", flex: 1 }}>
          <Text variant="sm-bold" color={colors.secondary.orchidBlue}>
            {t("home.statusCheckBox.title")}
          </Text>
          <Text variant="xs" numberOfLines={2}>
            {t("home.statusCheckBox.description")}
          </Text>
        </VStack>
        <Link to={IN_STATUS_CHECK} style={{ textDecorationLine: "none" }}>
          <Button variant="solid">
            <Text variant="xs" color={colors.neutral.cotton}>
              {t("home.statusCheckBox.button")}
            </Text>
          </Button>
        </Link>
      </HStack>
    </Flex>
  );
};

export default CheckStatusBox;
